// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LPzUK","left":"styles_left__2KbOp"};